import { Text } from '@consta/uikit/Text'
import { draftTooltipInTreeIsHidden } from '@core/core/constants'
import { getFromStorage } from '@core/core/helpers'
import { stringToBoolean } from '@library/utils'
import type { FC } from 'react'

import type { ObjectTreeNodeLabel } from '../types'
import css from './CustomLabel.css'
import { isDraftDetailed } from './helpers'

type PropsType = {
  objectTreeNode: ObjectTreeNodeLabel
}

export const TooltipContent: FC<PropsType> = ({ objectTreeNode }) => {
  const { isDraft, type } = isDraftDetailed(objectTreeNode)
  const draftTooltipIsHidden = getFromStorage(draftTooltipInTreeIsHidden, stringToBoolean)
  const showDraftTooltip = isDraft && !draftTooltipIsHidden

  let draftText: string

  switch (type) {
    case 'object': {
      draftText =
        'Это черновик. Чтобы его видели все, нажмите в контекстном меню объекта «Поделиться»'
      break
    }
    case 'folder': {
      draftText =
        'Это черновик. Чтобы все внутренние объекты видели все, нажмите в контекстном меню объекта «Поделиться». Уже опубликованные объекты заново публиковаться не будут'
      break
    }
    case undefined: {
      draftText = ''
    }
  }

  return (
    <div className={showDraftTooltip ? css.tooltipWidth : ''}>
      <Text size="xs" as="p" className={css.textTooltip} view="primary">
        {objectTreeNode.name}
      </Text>
      {!!showDraftTooltip && (
        <Text size="xs" as="p" fontStyle="italic" view="system" className={css.draftText}>
          {draftText}
        </Text>
      )}
    </div>
  )
}
